import React from 'react';
import { Spin } from 'antd';
import { isEqual, isEmpty } from 'lodash';
import {WeaTools, WeaErrorPage, WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
const { ls } = WeaTools;
import EHeader from '../common/EHeader';
import EContent from './EContent';
import FooterMore from "../common/FooterMore";
import { NoRightCom, handleHeight } from '../../util/common';
//元素组件
class EcodeElement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            edata: null,
            refresh: false,
        }
        this.handleEData = this.handleEData.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.onRef = this.onRef.bind(this);
        this.handleTabData = this.handleTabData.bind(this);

    }
    handleDelete(){
        const { config } = this.props;
        this.setState({
            edata: null,
        });
        ls.set('edata-'+this.props.config.params.eid+'-'+config.userid, null);
    }
    componentWillUnmount(){
        if(window.element_workflow_refresh && typeof window.element_workflow_refresh == 'object'){
            delete element_workflow_refresh[this.props.config.params.eid];
        }
    }
    handleRefresh(){
        this.setState({
            refresh: true,
        });
        let params = this.props.config.params;
        this.handleEData(params);
    }
    handleEData(params){
        const { eid, api } = params;
        const { config } = this.props;
        WeaTools.callApi(api || '/api/portal/element/ecodeelement', 'POST', {...params}).then(result => {
            ls.set('edata-'+eid+'-'+config.userid, result);
            this.setState({
                edata: result,
                refresh: false,
            });
        });
    }
    componentWillMount(){
        const { config = {} } = this.props;
        const { params = {} } = config;
        const { eid } = params;
        const edata = ls.getJSONObj(`edata-${eid}-${config.userid}`);
        if (config.islsdata && edata) {
            this.setState({ edata });
        } else {
            this.handleEData(params);
        }
    }
    componentWillReceiveProps(nextProps){
        const { item, params, isHasRight } = this.props.config;
        const config = { item, params, isHasRight };
        const _config = {
            item: nextProps.config.item,
            params: nextProps.config.params,
            isHasRight: nextProps.config.isHasRight,
        };
        if(!isEqual(config, _config) || nextProps.config.isRender){
            this.handleEData(nextProps.config.params);
        }
    }
    shouldComponentUpdate(nextProps, nextState){
        const { item, params, isHasRight } = this.props.config;
        const config = { item, params, isHasRight };
        const _config = {
            item: nextProps.config.item,
            params: nextProps.config.params,
            isHasRight: nextProps.config.isHasRight,
        };
        return !isEqual(this.state, nextState) || !isEqual(config, _config) || !isEmpty(nextProps.fontSizeMp)
    }
    onRef(ref){
        this.child = ref;
    }
    handleTabData(tabid){
        this.child.handleTabData(tabid)
    }
    render() {
        const { edata={}, refresh } = this.state;
        const { config, fontSizeMp } = this.props;
        if(!config || !edata) return <div/>;
        const { currenttab='1', tabids, titles, esetting={},counts,data={} } = edata;
        const { tabsetting={} } = data;
        const { showTab='2' } = tabsetting;
        const { isHasRight, item } = config;
        const { eid, ebaseid, content, header, contentview, style } = item;
        const { style: style1= {} } = contentview;
        const datas = {
            currentTab: currenttab,
            tabids,
            counts,
            titles,
            handleTabData: this.handleTabData,
            tabwidth: esetting.tabwidth,
            methodvalue: esetting.methodvalue,
            tabstyle: esetting.tabstyle,
            tabvalue: esetting.tabvalue,
            isAlwaysShow: esetting.isAlwaysShow,
        }
        let EContentHtml = <div/>;
        if(isHasRight){
            if(!isEmpty(edata)) EContentHtml = <EContent ecId={`${this && this.props && this.props.ecId || ''}_EContent@ar51uv`} onRef={this.onRef} config={config} fontSizeMp={fontSizeMp} handleDelete={this.handleDelete} handleRefresh={this.handleRefresh} edata={edata}/>;
        }else{
            EContentHtml = <NoRightCom ecId={`${this && this.props && this.props.ecId || ''}_NoRightCom@3mzc5v`}/>;
        }

        return <div className="item"
                    style={style}
                    id={`item_${eid}`}
                    data-eid={eid} data-ebaseid={ebaseid}
                    data-needRefresh={item.needRefresh}
                    data-cornerTop={item.cornerTop}
                    data-cornerTopRadian={item.cornerTopRadian}
                    data-cornerBottom={item.cornerBottom}
                    data-cornerBottomRadian={item.cornerBottomRadian}>
            <EHeader ecId={`${this && this.props && this.props.ecId || ''}_EHeader@8hidw0`} datas={datas} config={config} handleRefresh={this.handleRefresh} handleDelete={this.handleDelete} fontSizeMp={fontSizeMp}/>
            <div className="setting" id={`setting_${eid}`}></div>
            <div className="content" id={`content_${eid}`} style={{width:'auto',_width:'100%'}}>
                <div className="content_view" id={`content_view_id_${eid}`} style={{height: style1.height}}>
                    <Spin ecId={`${this && this.props && this.props.ecId || ''}_Spin@gl3ij6`} spinning={refresh}>{EContentHtml}</Spin>
                </div>
                <div style = {{textAlign:'right'}} id={`footer_${eid}`}><FooterMore ecId={`${this && this.props && this.props.ecId || ''}_FooterMore@zojypy`} config={this.props.config}/></div>
            </div>
        </div>;
    }
}

class MyErrorHandler extends React.Component {
    render() {
        const hasErrorMsg = this.props.error && this.props.error !== "";
        return ( <WeaErrorPage ecId={`${this && this.props && this.props.ecId || ''}_WeaErrorPage@0xn02i`} msg = { hasErrorMsg ? this.props.error : getLabel(385218,"对不起，该页面异常，请联系管理员！")  }/>
        );
    }
}
EcodeElement = WeaTools.tryCatch(React, MyErrorHandler, { error: "" })(EcodeElement);
export default EcodeElement;




// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/ecodeelement/index.js